import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  img: {
    maxWidth: '100%',
  },
});

export default useStyles;
